import { render, staticRenderFns } from "./SalesOrderViewerLabel.vue?vue&type=template&id=746a85f0"
import script from "./SalesOrderViewerLabel.vue?vue&type=script&lang=js"
export * from "./SalesOrderViewerLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports